<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Care centers</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>

        <m-carecenter-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-carecenter-form>
        <m-carecenter-edit-form :form="form" :carecenter="selectedItem" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-carecenter-edit-form>

        <v-card style="max-width:100%; position:relative">
          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          <v-spacer></v-spacer>
          <m-csv-btn class="pt-3" :disabled="true" :data="items" filename="carecenter.csv"></m-csv-btn>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :footer-props="{
                'items-per-page-options': [5, 10, 30, 40, {text:'All', value:-1}]
              }"
            >
            <template slot="items" slot-scope="props">
              <tr :class="{'error-item' :  inValidItem(props.item)}">
              <td >{{ props.item.id }}</td>
              <td >{{ props.item.name }}</td>
              <td >{{ props.item.email_address }}</td>
              <td >{{ props.item.tel }}</td>
              <td >{{ props.item.fullAddress }}</td>
              <td >{{ (props.item.visited === 1) ? 'yes' : '' }}</td>
              <td >{{ (props.item.marked === 1) ? 'yes' : '' }}</td>
              <td >{{ (props.item.subscribed_id) ? 'yes' : '' }}</td>
              <td class="justify-center layout px-0">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(props.item.id)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
              </td>
              </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import CareCenterMixin from '@/mixins/carecenter'

  export default {
    mixins: [CareCenterMixin],
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss">
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









